import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function XPostTriggerFullDetails({ trigger }: Props) {
  const executedWhenDisplay = useMemo(() => {
    if (!trigger.signature) return '-';

    // Extract post text from signature (e.g., "x-verify-post-Repost this tween and win a XBOX or PS5!!!")
    const postText = trigger.signature.split('x-verify-post-')[1];
    if (!postText) return '-';

    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        <Text as="span" variant="body-sm" color="muted">
          User posts:
        </Text>
        <Badge size="sm" className="tw:max-w-[400px] tw:whitespace-normal tw:break-words">
          {postText}
        </Badge>
      </div>
    );
  }, [trigger.signature]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
